import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import { sepratePriceFromComma } from "common/method/seprateNumberFromComma";
import { useEffect, useMemo } from "react";
import { getDataInLocalstorage } from "common/method/getDataInLocalstorage";
import { Skeleton, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as bestLimitsActionType } from "redux/offlineorder/select_best_limits";
let useStyles = makeStyles(() => ({
  rootBuy: {
    // height: "70vh",
    // minHeight: "400px",
    backgroundColor: "#dcdcf9",
  },
  rootSell: {
    // height: "70vh",
    // minHeight: "400px",
    backgroundColor: "#ffd7d7",
  },
  tables: {
    fontFamily: "iransans",
    "& thead th": {
      fontWeight: "500",
      fontSize: "10px",
      padding: "0px 0px",
      color: "#CECECE",
      borderBottom: "none",
      margin: 0,
      minWidth: 75,
    },

    "& tbody tr td": {
      fontSize: "12px",
      padding: 0,
      border: "none",
      margin: 0,
      minWidth: 75,
    },
    "& tbody tr": {
      borderBottom: "1px solid #EFEFEF",
    },

    "& tbody tr:last-child ": {
      borderBottom: "none !important",
    },
  },
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
  emptyCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
    fontSize: 16,
    marginTop: 25,
    border: "1px solid black",
    height: 30,
    // padding: 8,
    lineHeight: "2.8 !important",
    borderRadius: "4px !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "& td": {
    height: "20px !important",
    maxWidth: 100,
  },
  "& td div": {
    lineHeight: 1.8,
    textAlign: "center",
    borderRadius: 100,
    display: "inline-block",
    width: 80,
    marginRight: 15,
    marginLeft: 15,
  },
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th , &:last-child tr": {},
}));

const StockPrice = ({ symbol }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useMemo(() => getDataInLocalstorage(), []);
  const skeletonRows = Array.from({ length: 5 });
  const bestLimitsReducer = useSelector(
    (state) => state.select_best_limits_Reducer,
  );
  useEffect(() => {
    const fetchint = setInterval(() => {
      const data = symbol && { isin: symbol?.isin };

      dispatch({
        type: bestLimitsActionType.selectBestLimitsAsync,
        payload: { data: data },
      });
    }, 5000);

    return () => {
      clearInterval(fetchint);
      dispatch({ type: bestLimitsActionType.selectBestLimitsReset });
    };
  }, [symbol]);

  const rawData = bestLimitsReducer?.data;
  const buyArray = useMemo(() => {
    if (!rawData) return [];
    return Object.values(rawData).map((item) => ({
      NumberOfOrders: item.request_count,
      LimitQuantity: item.request_volume,
      LimitPrice: item.request_price,
    }));
  }, [rawData]);

  const sellArray = useMemo(() => {
    if (!rawData) return [];
    return Object.values(rawData)
      .filter((item) => item.offer_price > 0) // skip rows with no offer
      .map((item) => ({
        NumberOfOrders: item.offer_count,
        LimitQuantity: item.offer_volume,
        LimitPrice: item.offer_price,
      }));
  }, [rawData]);

  const checkMatchBuyPrice = (price) => null;
  // matchBuyPrice && matchBuyPrice.includes(parseInt(price));
  const checkMatchSellPrice = (price) => null;
  // matchSellPrice && matchSellPrice.includes(parseInt(price));

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      <TableContainer
        style={{ flex: 1, minWidth: 200 }}
        className={` ${classes["rootBuy"]}`}
      >
        <Table
          aria-label="simple table"
          className={`${classes["tables"]} table-auto`}
          style={{ marginBlock: "12px" }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <Typography fontSize={12} className="text-black">
                  تعداد
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography fontSize={12} className="text-black">
                  حجم
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography fontSize={12} className="text-black">
                  قیمت
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bestLimitsReducer?.loading &&
              skeletonRows.map((_, index) => (
                <StyledTableRow key={index}>
                  <TableCell align="center">
                    <Skeleton width={40} height={18} />
                  </TableCell>
                  <TableCell align="center">
                    <Skeleton width={60} height={18} />
                  </TableCell>
                  <TableCell align="center">
                    <Skeleton width={50} height={18} />
                  </TableCell>
                </StyledTableRow>
              ))}
            {!bestLimitsReducer?.loading && buyArray?.[0]?.LimitPrice && (
              <>
                {buyArray?.map((item, index) => {
                  const match = checkMatchBuyPrice(item?.LimitPrice);

                  return (
                    <StyledTableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="center">
                        {sepratePriceFromComma(item?.NumberOfOrders) || ""}
                      </TableCell>
                      <TableCell align="center">
                        {sepratePriceFromComma(item?.LimitQuantity) || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {/* <div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                // gap: 6,
                              }}
                            >
                              {match && <p>★</p>}
                              <p style={{}}>
                                {" "} */}
                        {sepratePriceFromComma(item?.LimitPrice)}
                        {/* </p>
                            </div>
                          </div> */}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </>
            )}

            {!bestLimitsReducer?.loading && !buyArray?.[0]?.LimitPrice && (
              <StyledTableRow>
                <TableCell align="center" colSpan={8}>
                  <div
                    style={{
                      display: "flex",
                      width: "70%",
                      padding: 1,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className={classes["emptyCard"]}
                  >
                    <Typography fontSize={12}>رکوردی یافت نشد</Typography>
                  </div>
                </TableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer
        style={{ flex: 1, minWidth: 200 }}
        className={` ${classes["rootSell"]}`}
      >
        <Table
          aria-label="simple table"
          className={`${classes["tables"]} table-auto`}
          style={{ marginBlock: "12px" }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <Typography fontSize={12} className="text-black">
                  قیمت
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography fontSize={12} className="text-black">
                  حجم
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography fontSize={12} className="text-black text-center">
                  تعداد
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bestLimitsReducer?.loading &&
              skeletonRows.map((_, index) => (
                <StyledTableRow key={index}>
                  <TableCell align="center">
                    <Skeleton width={50} height={18} />
                  </TableCell>
                  <TableCell align="center">
                    <Skeleton width={60} height={18} />
                  </TableCell>
                  <TableCell align="center">
                    <Skeleton width={40} height={18} />
                  </TableCell>
                </StyledTableRow>
              ))}
            {!bestLimitsReducer?.loading && sellArray?.[0]?.LimitPrice && (
              <>
                {sellArray?.map((item, index) => {
                  const match = checkMatchSellPrice(item?.LimitPrice);

                  return (
                    <StyledTableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        // style={{ display: "flex" }}
                        // className="flex  "
                        align="center"
                      >
                        {/* <div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                // gap: 6,
                              }}
                            >
                              {match && <p>★</p>}
                              <p style={{}}> */}{" "}
                        {sepratePriceFromComma(item?.LimitPrice)}
                        {/* </p>
                            </div>
                          </div> */}
                      </TableCell>
                      <TableCell align="center">
                        {sepratePriceFromComma(item?.LimitQuantity) || "-"}
                      </TableCell>

                      <TableCell align="center">
                        {sepratePriceFromComma(item?.NumberOfOrders) || ""}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </>
            )}

            {!bestLimitsReducer?.loading && !sellArray?.[0]?.LimitPrice && (
              <StyledTableRow>
                <TableCell align="center" colSpan={8}>
                  <div
                    style={{
                      display: "flex",
                      width: "70%",
                      padding: 1,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className={classes["emptyCard"]}
                  >
                    <Typography fontSize={12}>رکوردی یافت نشد</Typography>
                  </div>
                </TableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default StockPrice;
